module.exports = __webpack_public_path__ + "static/media/los-pinos-branco.a168545a.png";